<template>
  <NSelect class="n-it" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {computed} from 'vue';
import {isEmpty} from 'lodash-es';
import {useBootstrap} from '@front/hooks';

const props = defineProps({
  label: String,
  enumName: String,
  filter: () => {},
  optsDisabled: { type: Array, default: () => [] },
});

const { ENUMS } = useBootstrap();

const mOptions = computed(() => {
  let ret =
    ENUMS?.value?.[props.enumName].map(o => {
      return { label: o.label, value: o.name, disabled: !!props.optsDisabled.find(f => f === o.name) };
    }) ?? [];
  if (!isEmpty(props.filter)) ret = ret.filter(props.filter);
  return ret;
});

const attrs = computed(() => ({
  label: props.label,
  options: mOptions.value,
}));
</script>
